export const BLOG_POSTS_QUERY = `
  query BlogPosts($locale: SiteLocale!) {
    allBlogPosts(
      locale: $locale
      orderBy: _firstPublishedAt_DESC
      filter: { _locales: { allIn: [$locale] } }
    ) {
      id
      title
      authorName
      slug
      _locales
      _firstPublishedAt
      featuredImage {
        responsiveImage(imgixParams: { w: 800, h: 400, fit: crop }) {
          srcSet
          webpSrcSet
          sizes
          src
          alt
        }
      }
      seo {
        title
        description
        noIndex
        twitterCard
      }
    }
    _allBlogPostsMeta(locale: $locale, filter: { _locales: { allIn: [$locale] } }) {
      count
    }
  }
`
